/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_folder': {
    width: 16,
    height: 16,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M26.515 10.5l-5-7H0v53h60v-46H26.515zm5 7l-3.571-5H58v5H31.515z"/>'
  }
})
